import { DrawerLabel } from './DrawerLabel.tsx';

export const FlightChecklistDrawerLabel: React.FC = () => {
    return <DrawerLabel text="Advisories" />;
};
